import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Package } from 'src/models';
import {
  fetchPackagesAction,
  activatePackageAction,
  deactivatePackageAction,
} from 'src/services/packages';

const packagesEntityAdapter = createEntityAdapter({
  selectId: (pkg: Package) => pkg.id,
});

export const packagesSelectors = packagesEntityAdapter.getSelectors();

const initialState: {
  isPending: boolean;
  hasError: boolean;
} = {
  isPending: false,
  hasError: false,
};
const packagesSlice = createSlice({
  name: 'packages',
  initialState: packagesEntityAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPackagesAction.pending, (state) => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchPackagesAction.fulfilled, (state, { payload }) => {
      state.isPending = false;
      packagesEntityAdapter.setAll(state, payload);
    });
    builder.addCase(fetchPackagesAction.rejected, (state) => {
      state.isPending = false;
      state.hasError = true;
    });
    builder.addCase(
      activatePackageAction.fulfilled,
      (state, { meta, payload }) => {
        packagesEntityAdapter.updateOne(state, {
          id: meta.arg.packageId,
          changes: { active: payload.active },
        });
      },
    );
    builder.addCase(
      deactivatePackageAction.fulfilled,
      (state, { meta, payload }) => {
        packagesEntityAdapter.updateOne(state, {
          id: meta.arg.packageId,
          changes: { active: payload.active },
        });
      },
    );
  },
});

const { reducer } = packagesSlice;

export default reducer;
